import { IAjaxResponse, useHttpClient } from "@shesha-io/reactjs";
import useSWR from "swr";
import { URLS } from "./fetchers";
import { OrganisationalAccount } from "./models";

interface UseOrganisationalAccountsProps {
  organisationType?: string;
}

export const useOrganisationalAccounts = ({
  organisationType,
}: UseOrganisationalAccountsProps) => {
  const httpClient = useHttpClient();

  const fetcher = () => {
    const queryParams = organisationType
      ? `?orgType=${encodeURIComponent(organisationType)}`
      : "";
    return httpClient
      .get<
        IAjaxResponse<OrganisationalAccount[]>
      >(URLS.GET_ORGANISATIONS + queryParams)
      .then((res) => {
        const result = res.data.result;

        return result;
      });
  };

  return useSWR([URLS.GET_ORGANISATIONS, httpClient], fetcher, {
    refreshInterval: 0,
    revalidateOnFocus: false,
  });
};
